import {
    Button,
    HStack,
    Icon,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Portal,
    Text,
    VStack,
} from '@chakra-ui/react';
import { TbAddressBook, TbCopy } from 'react-icons/tb';
import { formatPhoneNumber } from '../functions';
import CopyButton from './CopyButton';

interface SupplierOrderInfoPopoverProps {
    label: string;
    displayId?: string | number | null;
    phone?: string | null;
    email?: string | null;
    compact?: boolean;
}

const CopyRow = ({
    value,
    display,
    label,
}: {
    value: string;
    display: string;
    label: string;
}) => (
    <HStack spacing={1.5} align="center">
        <Text fontSize="sm" color="fg.default" lineHeight="1.3" whiteSpace="nowrap">
            {display}
        </Text>
        <CopyButton
            text={value}
            label={label}
            iconAs={TbCopy as React.ComponentProps<typeof CopyButton>['iconAs']}
            iconSize={3.5}
            minW={0}
            h="auto"
            p={0.5}
        />
    </HStack>
);

const SupplierOrderInfoPopover = ({
    label,
    displayId,
    phone,
    email,
    compact = false,
}: SupplierOrderInfoPopoverProps) => {
    const hasDisplayId = displayId != null && String(displayId).length > 0;
    const hasPhone = !!phone;
    const hasEmail = !!email;

    if (!hasDisplayId && !hasPhone && !hasEmail) {
        return null;
    }

    return (
        <Popover placement="bottom-end" isLazy>
            <PopoverTrigger>
                <Button
                    size="xs"
                    variant="ghost"
                    iconSpacing={compact ? 1 : 2}
                    px={compact ? 1.5 : undefined}
                    leftIcon={
                        <Icon
                            as={TbAddressBook as React.ElementType}
                            boxSize={compact ? 3.5 : 4}
                        />
                    }
                >
                    {label}
                </Button>
            </PopoverTrigger>
            <Portal>
                <PopoverContent w="max-content" minW={0} maxW="none">
                    <PopoverArrow />
                    <PopoverBody px={2.5} py={2}>
                        <VStack align="flex-start" spacing={1}>
                            {hasDisplayId && (
                                <CopyRow
                                    value={String(displayId)}
                                    display={String(displayId)}
                                    label="Copy order ID"
                                />
                            )}
                            {hasPhone && (
                                <CopyRow
                                    value={phone}
                                    display={formatPhoneNumber(phone)}
                                    label="Copy phone"
                                />
                            )}
                            {hasEmail && (
                                <CopyRow
                                    value={email}
                                    display={email}
                                    label="Copy email"
                                />
                            )}
                        </VStack>
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    );
};

export default SupplierOrderInfoPopover;
